export default "__VITE_ASSET__D7TpqS$z__"